@if (model?.data) {
<div class="m-b-6-s">
    <!-- page image-->
    <div class="ratio-3-2">
        <img class="rf"
             [image]="model?.data?.image">
    </div>
    <div class="w-12 center m-t-3">
        <!-- page tags -->
        @for (tag of tagCategories; track $index) {
        <div [style]="client.isS ? 'min-width: 59px;': 'min-width: 75.5px;'"
             class="bg-col-5 m-a-1 inline-block">
            <span class="c1">{{tag.name}}</span>
        </div>
        }
        <!-- page name -->
        <h3 class="h3 m-t-3">{{model?.data?.name}}</h3>
        <!-- date and read time -->
        <div class="block va-m p1 col-13 m-t-2">
            <span class="inline-block">{{model?.data?.typeData?.date | date: 'MMMM dd, yyyy'}}</span>
            @if (model?.data?.typeData?.date && model?.data?.typeData?.reading_time) {
            &nbsp;&#124;&nbsp;
            <p class="inline-block">{{model?.data?.typeData?.reading_time}}</p>
            <i class="m-l-1 fs-6 va-m icon-clock inline-block"></i>
            }
        </div>
        <!-- button -->
        <button textButton
                class="m-t-3"
                [routerLink]="model?.data?.url"
                type="button"
                type="button">
            <span class="uppercase s1">{{'Read Article' | translate}}
            </span>
        </button>
    </div>
</div>
}